export default __webpack_public_path__ + "static/media/s1_male.66e78a35.wav";